import { Modal } from 'bootstrap';
import { getElement, getElements } from '../util';


/**
 * Manage a single API-backed select element's state. Each API select element is likely controlled
 * or dynamically updated by one or more other API select (or static select) elements' values.
 */
export class AddRelated {
    /**
     * Base `<a/>` DOM element.
     */
    private readonly wrapper: HTMLDivElement;

    private readonly select: HTMLSelectElement;

    private readonly link: HTMLLinkElement;

    private readonly id: string;

    private readonly href: string;

    private modal: Modal;

    constructor(wrapper: HTMLDivElement) {
        // Initialize readonly properties.
        this.wrapper = wrapper;
        this.select = wrapper.querySelector('select');
        this.link = wrapper.querySelector('.related-widget-wrapper-link');
        this.id = this.link.id;
        this.href = this.link.href;
        // this.name = base.name;
        // this.modal = new Modal(document.getElementById('relatedWidgetModal'), {})
        this.modal = this.createNewModal(document.getElementById('relatedWidgetModal'))
        this.setHxTarget()

        // Set up listeners
        this.link.addEventListener("click", (e) => this.handleClick(e));
        this.modal._element.addEventListener("hidden.bs.modal", (e: Event) => this.handleClose(e))
    }

    public fetchOptions = async () => {
        // TODO: Make the url dynamic
        const response = await fetch('/api/meters/meter/?limit=100');
        const options = await response.json();
        return options['results'];
    };

    public refreshSelectField = async () => {
        const options = await this.fetchOptions();
        // const selectField = this.select;

        console.log("Refreshing select " + this.select.id)

        this.select.innerHTML = '';
        options.forEach(option => {
            const optionElement = document.createElement('option');
            optionElement.value = option.id;
            optionElement.textContent = option.name;
            this.select.appendChild(optionElement);
        });
        // Set the selected option to the last option returned by the API (there's probably a better way to do this)
        this.select.selectedIndex = this.select.length - 1;
    };

    public handleClick(e: Event): void {
        console.log("AddRelated handleClick for link = " + this.id);
        // console.log(e)
        e.preventDefault()
        // this.modal.show()
        htmx.on("htmx:afterSwap", (e) => {
            // console.log("afterSwap...")
            // console.log(e)
            // Response targeting #dialog => show the modal
            if (e.detail.target.id == ("dialog" + "_" + this.id)) {
                // console.log("Displaying modal for " + this.id)
                this.modal.show();
            }
        });

        htmx.on("htmx:beforeSwap", (e) => {
            // Response targeting #dialog => show the modal
            // console.log("beforeSwap...")
            // console.log(e)
            if (e.detail.target.id == ("dialog" + "_" + this.id) && !e.detail.xhr.response) {
                this.modal.hide();
                e.detail.shouldSwap = false;
            }
        });
    }

    public handleClose(e: Event): void {
        console.log("The close handler for " + this.modal._element.id + " attached to " + this.select.id);
        // console.log(e)
        this.modal.innerHTML = "";
        console.log("Cleared modal content");
        this.refreshSelectField();
    }


    private createNewModal(template: HTMLElement): Modal {
        console.log("Create a new Modal for " + this.id)
        // console.log("Using Template ID = " + template.id)

        let newModalElement = template.cloneNode(true)
        newModalElement.id = template.id + "_" + this.id
        // console.log("New Modal ID = " + newModalElement.id)

        // console.log("Searching children for dialog...")
        newModalElement.childNodes.forEach((node) => {
            if (node.id == "dialog") {
                // console.log("Found dialog id = " + node.id)
                node.id = node.id + "_" + this.id
                // console.log("New dialog ID = " + node.id)
            }
        });

        // Insert the new modal into the DOM
        template.after(newModalElement);
        // console.log("---Modal added to DOM, completed")

        // Initiate and return
        return new Modal(newModalElement, {});
    }

    private setHxTarget(): void {
        // console.log("Updating hx-target for " + this.id)
        this.link.setAttribute("hx-target", "#dialog_" + this.id)

    }
}

export function initAddRelated(): void {
    for (const wrapper of getElements<HTMLDivElement>('.related-widget-wrapper')) {
        // Don't initialize the template
        if (wrapper.querySelector('select').id.search("__prefix__") == -1) {
            new AddRelated(wrapper)
        }
    };
    // for (const link of getElements<HTMLLinkElement>('.related-widget-wrapper-link')) {
    //     new AddRelated(link);
    // }

    function containsChildWrapper(node: Node): boolean {
        // console.log("Searching for related-widget-wrapper")
        if (node.classList?.length > 0) {
            if (node.classList.contains("related-widget-wrapper")) {
                // console.log("**FOUND** related widget wrapper")
                return true;
            }
        }
        for (const child of node.childNodes) {
            if (child.classList?.length > 0) {
                if (child.classList.contains("related-widget-wrapper")) {
                    // console.log("**FOUND** related widget wrapper")
                    return true;
                }
            }
            if (child.childNodes.length > 0) {
                // recurse into the children
                if (containsChildWrapper(child)) {
                    return true;
                }
            }
        }
        return false;
    }


    var mutationObserver = new MutationObserver((mutationList, observer) => {
        // console.log(mutationList)
        for (const mutation of mutationList) {
            if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                // console.log("A child node has been added.");

                for (var j = 0; j < mutation.addedNodes.length; j++) {
                    var addedNode = mutation.addedNodes[j];
                    // console.log(addedNode)
                    if (containsChildWrapper(addedNode)) {
                        // Initialize the AddRelated() class for the new element.
                        // console.log("Initializing AddRelated for new row")
                        htmx.process(addedNode)
                        new AddRelated(addedNode.querySelector(".related-widget-wrapper"));

                    } else if (mutation.type === "childList" && mutation.removedNodes.length > 0) {
                        // console.log("A child node has been removed.");
                    }
                }
            }
        }
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, subtree: true });
}